import { render, staticRenderFns } from "./BlacklistContact.vue?vue&type=template&id=052d354c&scoped=true"
import script from "./BlacklistContact.vue?vue&type=script&lang=js"
export * from "./BlacklistContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d354c",
  null
  
)

export default component.exports